<template>
  <div class="teacher-main-wrapper">
    <div
      style="padding: 30px 0; margin: 0 auto; width: 1200px"
      class="teacher-wrapper"
    >
      <div class="main-title">
        <span class="text">推荐教师</span>
        <!-- <span class="eng">Recommended Teachers</span> -->
        <a
          :href="`${$schoolUrl}/teacherList.html`"
          class="more-btn"
          style="margin-top: 14px"
        >
          <span class="btn-text">查看全部</span>
          <i class="iconfont icongengduo"></i>
        </a>
      </div>
      <div class="teacher-list">
        <template v-if="teacherList && teacherList.length">
          <TeacherCard
            v-for="teacherData in teacherList"
            :teacherData="teacherData"
            :key="teacherData.teacher_id"
            class="teacher-card"
          >
          </TeacherCard>
        </template>
        <EmptyIcon v-else type="people" text="暂无推荐教师" />
      </div>
    </div>
  </div>
</template>
<script>
import config from "../../config";
import TeacherCard from "components/TeacherCard";
import EmptyIcon from "components/EmptyIcon";
export default {
  components: {
    TeacherCard,
    EmptyIcon,
  },
  created() {
    this.getTeacherList();
  },
  data() {
    return {
      teacherList: [],
      dialogTeacherVisible: false,
      currentTeacher: {},
      abbr: config.abbr,
    };
  },
  methods: {
    async getTeacherList() {
      const list = await this.$http.nuc.getHomeTeacherList();
      this.teacherList = list.slice(0, 4);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/index";
.teacher-main-wrapper {
  font-size: 0;
  background: url(~assets/images/home/teacher_bg.png) rgb(224, 234, 255);
}

.teacher-main-wrapper .teacher-wrapper {
  margin-right: 30px;
  vertical-align: top;
}

.teacher-main-wrapper .teacher-list {
  display: flex;
  justify-content: space-between;
  margin-top: 43px;
  .teacher-card {
    margin-right: 0;
    margin-bottom: 0;
    & + .teacher-card {
      margin-left: 16px;
    }
  }
}
</style>